"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDebounce = useDebounce;
exports.default = void 0;

var _react = require("react");

/**
 * useDebounce — This hook returns a tuple consisting of a state value,
 * and an update function for changing the state value. The update function is
 * debounced to force update requests to wait a certain amount of time before
 * running again.
 */
function useDebounce(initialValue, delay) {
  const [value, updateValue] = (0, _react.useState)(initialValue);
  const timeoutRef = (0, _react.useRef)();

  const callback = nextValue => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        timeoutRef.current = undefined;
        updateValue(nextValue);
      }, delay);
    }
  };

  (0, _react.useEffect)(() => () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = undefined;
    }
  }, [initialValue, delay]);
  return [value, (0, _react.useCallback)(callback, [updateValue, delay])];
}

var _default = useDebounce;
exports.default = _default;
//# sourceMappingURL=useDebounce.js.map